/* eslint-disable @typescript-eslint/ban-ts-comment */
import { withStyles } from '@material-ui/core/styles'
import BaseTooltip, { TooltipProps } from '@material-ui/core/Tooltip'
import styled, { DefaultTheme } from 'styled-components'
import { withRoutePlanningTheme } from '@seller-hermes/theme/hoc';

const mapColors = ({ theme }: { theme: DefaultTheme }) =>
  theme.type === 'light'
    ? { $bg: theme.colors.white[1000], $color: theme.colors.black[1000] }
    : { $bg: theme.colors.black[1000], $color: theme.colors.white[1000] }

const BaseNewTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.background.default,
    boxShadow: theme.shadows[1],
    color: theme.palette.getContrastText(theme.palette.background.default),
    fontSize: '1.2rem',
    padding: '10px 20px',
    maxWidth: '500px',
  },
}))(BaseTooltip)

const NewTooltipWithoutTheme = styled(BaseNewTooltip as any).attrs((p) => ({
  ...mapColors(p),
  enterDelay: 500,
  interactive: p.interactive === undefined ? p.interactive : true,
}))``

const NewTooltip = withRoutePlanningTheme<TooltipProps>(
  NewTooltipWithoutTheme as any,
)

export default NewTooltip
